import React from 'react';
import { useTranslation } from 'react-i18next';
import './AdminModal.css';

export default function AddonManagementModal({
  item,
  addons,
  loading,
  onClose,
  onAddCategory,
  onEdit,
  onDelete,
}) {
  const { t } = useTranslation();

  return (
    <div className="adm-modal-overlay adm-modal-overlay--stacked" onClick={onClose}>
      <div className="adm-modal adm-modal--narrow" onClick={(e) => e.stopPropagation()}>
        <div className="adm-modal__header">
          <h3 className="adm-modal__title">{t('admin.addons.title', { name: item.name })}</h3>
          <button type="button" className="btn btn-secondary adm-modal__close" onClick={onClose}>×</button>
        </div>
        {loading ? (
          <p style={{ color: 'var(--text-muted)' }}>{t('common.loading')}…</p>
        ) : (
          <>
            <div style={{ marginBottom: '1rem' }}>
              {addons.length === 0 ? (
                <p style={{ color: 'var(--text-muted)', margin: 0 }}>{t('admin.addons.noAddons')}</p>
              ) : (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {addons.map((addon) => {
                    const optionNames = (addon.options || []).map((o) => o.name).filter(Boolean);
                    const summary = optionNames.slice(0, 4).join(', ');
                    const extra = optionNames.length - 4;
                    return (
                      <li key={addon.id} style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '0.75rem',
                        padding: '0.625rem 0', borderBottom: '1px solid var(--border-light)',
                      }}>
                        <span style={{ minWidth: 0 }}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', flexWrap: 'wrap' }}>
                            <strong>{addon.categoryName}</strong>
                            <span style={{ color: 'var(--text-secondary)', fontSize: '0.85em' }}>
                              ({addon.options?.length || 0} {t('admin.addons.options')})
                            </span>
                            {addon.isRequired && <span className="adm-addon-badge adm-addon-badge--required">{t('admin.addons.requiredBadge')}</span>}
                            {addon.allowMultiple && <span className="adm-addon-badge adm-addon-badge--multiple">{t('admin.addons.multipleBadge')}</span>}
                          </span>
                          {summary && (
                            <span style={{
                              display: 'block', color: 'var(--text-secondary)', fontSize: '0.85em', marginBlockStart: '0.25rem',
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            }}>
                              {summary}{extra > 0 ? `, +${extra}` : ''}
                            </span>
                          )}
                        </span>
                        <span style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                          <button type="button" className="btn btn-secondary btn-small" onClick={() => onEdit(addon)}>{t('common.edit')}</button>
                          <button type="button" className="btn btn-secondary btn-small" onClick={() => onDelete(addon.id)}>{t('common.delete')}</button>
                        </span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
            <button type="button" className="btn btn-primary" onClick={onAddCategory}>
              ＋ {t('admin.addons.addCategory')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
